<template>
    <div>
        <!-- MODAL ADD TRAVAUX -->
        <v-dialog v-model="dialogAjoutTache"  :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Dupliquer les tâches de {{this.libelleChantier}}/{{libelleTacheSelect}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="closeForm()" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading">
                   <v-layout row >
                            <v-flex md5>
                              <div class="block">
                                <span class="demonstration">Type chantier *</span>
                                <el-select
                                  v-model="typeProjet"
                                  placeholder="Selectionné un type projet"
                                   v-on:change="loadTrvBytype(typeProjet)"
                                  style="width:100%"
                                >
                                  <el-option
                                    v-for="item in typeProjetTab"
                                    :key="item.id"
                                    :label="item.libelle"
                                    :value="item.id"
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                            </v-flex>
                            <v-flex md2></v-flex>
                            <v-flex md5>
                              <div class="block">
                                <span class="demonstration">Type Travaux *</span>
                                <el-select
                                 clearable
                                  v-model="typeSelectTravaux"
                                  placeholder="Selectionné un type travaux"
                                  style="width:100%"
                                >
                                  <el-option
                                    v-for="item in listTravauxTab"
                                    :key="item.id"
                                    :label="item.libelle"
                                    :value="item.id"
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                            </v-flex>
                      </v-layout>
                      <br/>
                    <el-form :rules="rulesLotTache" id="formLotTache"  label-position="top" ref="formLotTache"  :model="formLotTache" class="demo-ruleForm" >
                        <v-layout row >
                            <v-flex xs1 mr-1>
                                <el-form-item
                                        label="Ordre" prop="ordre">
                                    <el-select v-model="formLotTache.ordre" placeholder="Select">
                                        <el-option
                                                v-for="(item,index) in numOrdre"
                                                :key="index"
                                                :label="item.num"
                                                :value="item.num">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </v-flex>

                            <v-flex xs3 mr-1>
                                <el-form-item
                                        label="Libelle tâche" prop="libelle">
                                    <el-input placeholder="Saisir un libelle"  name="libelle"    v-model="formLotTache.libelle"></el-input>
                                </el-form-item>
                            </v-flex>

                            <v-flex xs3 mr-1 >
                                <el-form-item
                                        label="Unité" prop="unite">
                                    <el-input placeholder="unité"  name="unite"    v-model="formLotTache.unite"></el-input>
                                </el-form-item>
                            </v-flex>
                            <v-flex xs3 mr-1 >
                                <el-form-item
                                        label="Prix unitaire (FCFA)" prop="prix">
                                    <el-input-number  :min="0"   name="prix"    v-model="formLotTache.prix"></el-input-number>
                                </el-form-item>
                            </v-flex>

                            <v-flex xs4 mr-1>
                                <el-form-item
                                        label="Description" prop="description">
                                    <el-input type="textarea" placeholder="description"  name="description" :rows="6"    v-model="formLotTache.description"></el-input>
                                </el-form-item>
                            </v-flex>

                            <v-flex xs1>
                                <el-form-item
                                        label="Action" >
                                <v-btn icons color="primary"  @click="addListTypeTache()" fab small dark> <v-icon>add</v-icon></v-btn>
                                </el-form-item>
                            </v-flex>

                        </v-layout>
                        <div class="text-xs-right" v-if="typeSelectTravaux !=''">
                              <input
                                      name="fileInputExcel"
                                      type="file"
                                      style="display:none"
                                      ref="fileInputExcel"
                                      accept="image/*"
                                      @change="onFileExcelPicked"
                              />
                              <el-dropdown @command="handleFileExcel">
                                  <el-button type="success">
                                      Fichier excel<i class="el-icon-arrow-down el-icon--right"></i>
                                  </el-button>
                                  <el-dropdown-menu slot="dropdown">
                                      <el-dropdown-item command=0>Importer fichier excel</el-dropdown-item>
                                      <el-dropdown-item command=1>Générer un modèle</el-dropdown-item>
                                  </el-dropdown-menu>
                              </el-dropdown>

                    </div>
                          <br/>

                        <v-layout row wrap >
                            <v-flex xs12>

                                <el-table :data="listeTaches" border
                                          style="width: 100%" >
                                    <el-table-column  prop="ordre" label="Ordre"   >
                                        <template slot-scope="prop">
                                        <el-select v-model="prop.row.ordre" placeholder="Select" @change="changeOrdre(prop.row.ordre,prop.$index)">
                                            <el-option
                                                    v-for="(item,index) in listeNumber"
                                                    :key="index"
                                                    :label="item.num"
                                                    :value="item.num">
                                            </el-option>
                                        </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column  prop="libelle" label="Libellé tâche"  >
                                        <template slot-scope="prop">
                                        <el-input controls-position="right" size="small" v-model="prop.row.libelle"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column  prop="unite" label="unité"   >
                                        <template slot-scope="prop">
                                            <el-input     controls-position="right" size="small" v-model="prop.row.unite"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column  prop="prix" label="Prix unitaire (FCFA)"   >
                                        <template slot-scope="prop">
                                            <el-input-number   :min="0"   name="prix"   v-model="prop.row.prix"></el-input-number>
                                        </template>
                                    </el-table-column>
                                    <el-table-column  prop="description" label="description"   >
                                        <template slot-scope="prop">
                                            <el-input type="textarea"    controls-position="right" size="small" v-model="prop.row.description"></el-input>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="Opérations" align="center">
                                        <template slot-scope="scope">
                                            <v-tooltip top>
                                                <v-btn slot="activator" fab small icons color="red"  @click.native.prevent="deleteRow(scope.$index, listeTaches)" dark>
                                                    <v-icon center>delete</v-icon>
                                                </v-btn>
                                                Supprimer cette tâche
                                            </v-tooltip>
                                        </template>

                                        <template slot-scope="scope">
                                            <v-tooltip top>
                                                <v-btn slot="activator" fab small icons color="red"  @click.native.prevent="deleteRow(scope.$index, listeTaches)" dark>
                                                    <v-icon center>delete</v-icon>
                                                </v-btn>
                                                Modifier cette tâche
                                            </v-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </v-flex>

                            <!--Bouton valider-->
                            <v-flex xs12 sm12 align-self-end mt-4  >
                                <v-divider ></v-divider>
                                <v-layout row wrap>
                                    <v-flex xs2  class="pr-1"     offset-xs8>
                                        <v-btn block @click="closeForm()" color="grey"  dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                                    </v-flex>

                                    <v-flex xs2  >
                                        <v-tooltip top>
                                            <v-btn slot="activator"  v-if="typeSelectTravaux !=''"  disable  icons block color="green" @click="submitDupTache()" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                            </v-flex>




                        </v-layout>

                    </el-form>
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <LoadTypeTachesExcel @close="showModalLoadTypeTravaux = false" :show = "showModalLoadTypeTravaux" :listeTypeTravaux="lstTypeTravaux" :idTypeTravaux = this.typeSelectTravaux></LoadTypeTachesExcel>

    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    import LoadTypeTachesExcel from "@/components/divers/loadTypeTaches.vue";

    export default {
        name: "formTypeTache",
        components:{ Loading,LoadTypeTachesExcel },
        props:{
            show: {
                type: Boolean,
                default: false,
            },
            listeLotTache: {
                type: Array,
                default: new Array()
            },
            idTypeTravaux:{
                type: Number,
                default: null
            },
              typeProjetTab: {
                type: Array,
                default: new Array()
            },
            libelleTacheSelect:{
              type: String,
              default: null
            },
            libelleChantier:{
              type: String,
              default: null
            }

        },
        data(){
            return{
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

                loading: false,
                dialogAjoutTache: false,
                typeProjet: '',
                typeSelectTravaux:'',
                listeTaches:[],
                listTravauxTab: [],
                formLotTache:{
                    idTypeTache: null,
                    ordre:"",
                    libelle:"",
                    unite:"",
                    prix:1,
                    description:""

                },
                rulesLotTache:{
                    ordre: [
                        { required: true, message: 'Veuillez selectionnez un numéro d\'ordre', trigger: 'blur' }
                    ],
                    libelle:[
                        {required:true, message: "Veuillez  saisir un type de tache",trigger: 'blur' }
                    ],
                    unite:[
                        {required:true, message: "Veuillez  saisir une unite",trigger: 'blur' }
                    ],
                    prix:[
                        {required:true, message: "Veuillez  saisir un prix unitaire",trigger: 'blur' }
                    ]
                },
                numOrdre: [],
                numOrdreCopie: [],
                listeTacheSupp:[],

                showModalLoadTypeTravaux: false,
                //Importer fichier excel
                fileExcel: [],
                lstTypeTravaux:[]
            }
        },
        watch:{
            show: function(newValue, oldValue){
                if(newValue == true){
                    this.listeTaches.splice(0)
                    this.numOrdre.splice(0)
                    this.dialogAjoutTache = true;
                    this.numOrdre.push({num:1})
                    if(this.listeLotTache.length > 0)
                    {
                        this.numOrdre.splice(0)
                        //rechechons lordre le plus eleve
                        let ordreSup = null;
                        this.listeLotTache.forEach( (elt,ind) =>{
                            if( (ind+1) <  this.listeLotTache.length ){
                                let prochainOrdre = this.listeLotTache[ind+1].ordre
                                if( prochainOrdre > elt.ordre   ){
                                    ordreSup = prochainOrdre
                                }else{
                                    ordreSup = elt.ordre
                                }
                            }

                        });

                        this.listeTaches = this.listeLotTache.slice();

                        this.numOrdreCopie.splice(0)
                        let nbLots = this.listeLotTache.length
                        this.numOrdre.push({num:(ordreSup+1)})

                        if( this.listeTaches.length  == 1  ){
                            this.numOrdre.push({num:2})
                        }

                        for(let i=0;i<=nbLots;i++){
                            this.numOrdreCopie.push({num:(i+1)})
                        }
                    }
                }else{
                    this.dialogAjoutTache = false;
                }
            }
        },
        computed: {
            listeNumber: function(){
                let listeNum = this.numOrdreCopie.slice();
                return  listeNum.filter(elt => {
                    if(elt.num <= (this.listeTaches.length)){
                        return elt;
                    }
                } )
            }
        },
        methods:{
            changeOrdre(value, ind)
            {
            },
            submitDupTache (){
                if(this.typeSelectTravaux == null){
                    this.$message.error('Aucun travaux selectionné');
                    return;
                }
                this.loading = true
                    let url = this.domaine +'projet/new/duplicate/tache/projet'

                    //recuperer les uniquement les lots de travaux
                let nbData = 1;
                if(this.listeTaches.length >10){
                    nbData = 10;
                }

                let nbReq = Math.round(this.listeTaches.length / nbData);
                let nbRest = this.listeTaches.length % nbData;
                if(nbRest >0){
                    nbReq += 1;
                }

                if( nbReq == 0 && this.listeTacheSupp.length > 0  ){
                    nbReq = 1;
                }

                bloc_1: {
                    for(let i=0; i<nbReq;i++)
                    {
                        let initJ = i*nbData;
                        let finJ = (i+1)*nbData;
                        let dataLot = [];
                        dataLot.splice(0);
                        if(this.listeTaches.length > 0){
                            for(let j = initJ;j < finJ;j++){
                                if(this.listeTaches[j] == undefined){
                                    break ;
                                }
                                dataLot.push(this.listeTaches[j]);
                            }
                        }

                        if(dataLot.length == 0 && this.listeTacheSupp.length == 0){
                            break bloc_1;
                        }
                        let data = new FormData()
                        
                        let ligne = null;
                        for (let prop in dataLot) {
                        ligne = dataLot[prop];
                            data.append("option[ordre][]", ligne.ordre);
                            data.append("option[unite][]", ligne.unite);
                            data.append("option[libelle][]", ligne.libelle);
                            data.append("option[prix][]", ligne.prix);
                            data.append("option[idTypeTache][]", ligne.idTypeTache);
                            data.append("option[description][]", ligne.description);
                        }

                        data.append('type', this.typeSelectTravaux)
                        data.append('idUser', this.user.id)
                        // data.append("lots", JSON.stringify(dataLot));
                        data.append("listeSupp", JSON.stringify(this.listeTacheSupp));


                        this.$http.post(url, data).then(response => {
                                if(response.body.code == 1 && i == (nbReq-1) ){
                                    this.$notify({
                                        title: 'Suppression travaux',
                                        duration:10000,
                                        message: response.body.message + response.body.lstTacheNonSupp,
                                        type: 'warning'
                                    });
                                }


                                this.$notify({
                                    title: 'ENREGISTREMENT REUSSI',
                                    message: 'Lot enregistré avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                })


                            },
                            response => {
                                this.$message.error("Erreur lors de l'enregistrement des lots de travaux")
                                this.loading = false
                            })

                    }


                }

                this.loading = false
                this.closeForm()
            },
            closeForm(){
                this.$emit("close")
                this.resetForm();
                this.typeProjet =""
                this.typeSelectTravaux =""

            },
            deleteRow(index, rows) {
                let ordreIndex = this.listeTaches[index].ordre;
                let indexpos = this.numOrdre.findIndex(elt=>
                    elt.num > ordreIndex
                );
                let indexposCopie = this.numOrdreCopie.findIndex(elt=>
                    elt.num == ordreIndex
                );

                this.numOrdre.splice(indexpos,0,{num:ordreIndex});
                this.numOrdreCopie.splice(indexposCopie,1);

                //enregistrer lid du lot de travaux supprimer dans la liste
                if(this.listeTaches[index].idTypeTache != null){
                    this.listeTacheSupp.push(this.listeTaches[index].idTypeTache);
                }

                rows.splice(index, 1);
                if(this.listeTaches.length <=0){
                    this.numOrdre.splice(0);
                    this.numOrdreCopie.splice(0);

                    this.numOrdre.push({num:1})
                    this.numOrdreCopie.push({num:1})
                }

            },
             handleFileExcel(command) //0=>Importer,1=>generer
            {
                switch(command){
                    case "0": //importer un fichier
                        this.$refs.fileInputExcel.click()
                        break;
                    case "1": //generer un modele un fichier
                        this.generateFileExcel()
                        break;
                }
            },
             generateFileExcel(){
                let url = this.domaine + 'projet/generer/modele/travaux/taches'
                window.open(url)
            },
             onFileExcelPicked(event){
                this.fileExcel.splice(0, 1);
                const files = event.target.files;
                let filename = files[0].name;

                if (filename.lastIndexOf(".xls") <= 0 ) {
                    return alert("Veuillez selectionner un fichier excel valide ");
                }
                if (files[0].size > 1048576) {
                    this.$message.error("La taille du fichier est supérieur à 1024 ko");
                    return;
                }

                const fileReader = new FileReader();
                fileReader.addEventListener("load", () => {
                    this.fileExcel.push(fileReader.result);
                });


                fileReader.readAsDataURL(files[0]);


                let url = this.domaine + "tache/load_Travaux_tache/excel";
                let data = new FormData();
                //emvoie du fichier

                data.append("fichierExcel", files[0], files[0][name]);
               this.closeForm()
                this.$http.post(url, data).then(
                    resp => {
                        this.loading = false;

                        this.$notify({
                            title: "Chargement liste type travaux",
                            message: "Chargement effectué",
                            type: "success",
                            position: "top-right",
                            duration: 7000
                        });
                        this.lstTypeTravaux = resp.body.listeTypeTravaux
                        this.showModalLoadTypeTravaux = true
                    },
                    resp => {
                        this.loading = false;
                        this.$message.error(
                            "Erreur lors de l'importation du fichier"
                        );
                    }
                )


            },
            addListTypeTache() {
                this.$refs["formLotTache"].validate((valid) => {
                    if(valid){
                        let lenListelot = this.listeTaches.length;
                        let indiceInsert = this.formLotTache.ordre-1
                        this.listeTaches.splice(indiceInsert,0,
                            {
                                idTypeTache : this.formLotTache.idTypeTache,
                                libelle : this.formLotTache.libelle,
                                unite : this.formLotTache.unite,
                                prix : this.formLotTache.prix,
                                ordre :  this.formLotTache.ordre,
                                description :  this.formLotTache.description,
                            }
                        )
                        let index = this.numOrdre.findIndex( elt =>
                            elt.num == this.formLotTache.ordre
                        );
                        let dernierChif = this.numOrdre[this.numOrdre.length-1].num

                        this.numOrdre.splice(index,1);

                        this.numOrdre.push({num:dernierChif+1})
                        this.resetForm()
                    }
                });
            },
            loadTrvBytype(item){
              this.loading = true;
              let url = this.domaine + "projet/travauxSelect/" + item;
              this.$http.get(url).then(response => {
                if (response.body) {
                  this.loading = false;
                  this.listTravauxTab = response.body.detailtravaux;
                }
              },
                response => {
                    this.$message.error("Erreur lors de l'enregistrement des lots de travaux")
                    this.loading = false
                });
            },
            resetForm() {
                this.$refs["formLotTache"].resetFields();
                this.formLotTache.libelle = "";
                this.formLotTache.unite = "";
                this.formLotTache.prix = 1;
                this.formLotTache.description = "";
                this.listeTacheSupp.splice(0)
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/divers/formdupplication/dupformTypeTache.vue